import { JsonPatchOperation } from '@core/data/models/json-patch.model';

export interface TextBlock {
  id: number;
  name: string;
  textBlockCategoryId: number;
  textBlockAreaId: number;
  createdAt?: Date;
  updatedAt?: Date;
  content: string;
  sortSequence?: number;
}

export interface TextBlockView extends TextBlock {
  textBlockCategoryDescription: string;
  textBlockAreaDescription: string;
  textBlockCategorySortSequence?: number;
}

export function toPatchOperations(
  changes: Partial<TextBlock>
): JsonPatchOperation[] {
  const operations: JsonPatchOperation[] = [];

  Object.entries(changes).forEach(([key, value]) => {
    if (value !== undefined) {
      operations.push({
        op: 'replace',
        path: `/${key}`,
        value: value,
      });
    }
  });

  return operations;
}
